module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "specials-rw BriefTOC-rw exclude-print-rw",
    attrs: {
      "id": "BriefTOC1"
    }
  }, [_c('div', {
    staticClass: "fixed-rw"
  }, [_c('span', {
    attrs: {
      "href": "#/toc#toc-welcome",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "CoverImage",
      "src": "images/9781401396374_c.jpg",
      "title": "Cover"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "block-rw list-toc-rw",
    attrs: {
      "id": "list-toc1"
    }
  }, [_c('p', {
    staticClass: "welcome"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_c('strong', [_vm._v("Begin Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "welcome"
  }, [_c('span', {
    attrs: {
      "href": "#/toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "welcome"
  }, [_c('span', {
    attrs: {
      "href": "#/newsletterSignup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Newsletters")])]), _vm._v(" "), _c('p', {
    staticClass: "welcome"
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "welcome-notice",
    attrs: {
      "id": "disclaimer1"
    }
  }, [_vm._v("Hachette Book Group supports the right to free expression and the value of copyright. The purpose of copyright is to encourage writers and artists to produce the creative works that enrich our culture.")]), _vm._v(" "), _c('p', {
    staticClass: "welcome-notice",
    attrs: {
      "id": "disclaimer2"
    }
  }, [_vm._v("The scanning, uploading, and distribution of this book without permission is a theft of the author’s intellectual property. If you would like permission to use material from the book (other than for review purposes), please contact permissions@hbgusa.com. Thank you for your support of the author’s rights.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84bf9140","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcome.vue
// module id = 63
// module chunks = 0